import React, { useEffect, useRef, useState } from "react";
import Icon1 from "../icons/Icon";

function DropDownGPT1({
  label,
  disabled = false,
  items,
  value,
  onChange,
  className,
  mandatory = false,
}) {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);
  const [openUpwards, setOpenUpwards] = useState(null);

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      // If there's more space above than below, open upwards
      setOpenUpwards(spaceAbove > spaceBelow && spaceBelow > 200);
    }
  }, [isOpen]);

  // Filter items based on the input query
  const filteredItems = items.filter((item) =>
    item.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (item) => {
    onChange(item);
    setQuery(""); // Clear query after selection
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    if (value) {
      onChange(null); // Reset selected value if a new query is being typed
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && value) {
      onChange(null); // Reset selected value
      setQuery(""); // Clear the query
    }
  };

  return (
    <div className={`relative ${className}`}>
      <div
        onFocus={() => !disabled && setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        className="relative"
      >
        <div className="absolute right-2 top-1/4 pointer-events-none">
          <Icon1 icon_name="down" size={18} fill="grey" />
        </div>
        <input
          ref={dropdownRef}
          type="text"
          disabled={disabled}
          className={`w-full px-3 py-1 border border-gray-300 rounded-xl shadow-sm ${disabled ? "cursor-default text-shadow_25 focus:outline-none focus:ring-transparent focus:border-neutral-300 focus:border-1" : "focus:outline-none focus:ring-blue-300 focus:border-blue-300 focus:border-2 "} ${disabled ? "bg-neutral-100 border-neutral-300" : value ? "bg-white" : "bg-transparent"}  ${
            isOpen || disabled ? "" : "cursor-pointer"
          } ${mandatory && value == null ? "border-red-500" : ""} sm:text-sm  `}
          placeholder={label}
          value={value?.label ? value.label : query ? query : ""}
          onChange={handleInputChange}
          onClick={() => (disabled ? {} : setIsOpen(true))}
          onKeyDown={handleKeyDown} // Handle backspace key
          autoComplete="zzz"
        />
        {isOpen && openUpwards !== null && (
          <ul
            className={`absolute z-50 w-full  flex flex-col max-h-c300 bg-white shadow-xl  h-auto rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm  ${openUpwards ? "bottom-full mb-1" : "top-full mt-1"}`}
          >
            {filteredItems.map((item, index) => (
              <li
                key={index}
                className={`cursor-pointer select-none relative py-2 pl-3 pr-9 ${
                  value !== null && value.value === item.value
                    ? "text-indigo-800 bg-indigo-100"
                    : "text-gray-900"
                }`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handleSelect(item)}
              >
                <div className="flex items-center">
                  <span
                    className={`ml-3 block truncate ${
                      value !== null && value.value === item.value
                        ? "font-semibold"
                        : ""
                    }`}
                  >
                    {item.label}{" "}
                    {item.extra_label && (
                      <span
                        className={` ${item.client_type ? (item.client_type === "purple" ? "text-purple-400 bg-purple-50" : item.client_type === "indigo" ? "text-indigo-400 bg-indigo-50" : "text-blue-400 bg-blue-50") : "text-blue-400 bg-blue-50"}  font-light  rounded-full px-1 text-h4 ml-1`}
                      >
                        {item.extra_label}
                      </span>
                    )}
                  </span>
                </div>
                {value !== null && value.value === item.value ? (
                  <span className="absolute inset-y-0 right-0 flex items-center pr-4">
                    <svg
                      className="h-5 w-5 text-indigo-800"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 5.707 8.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                ) : null}
              </li>
            ))}
            {filteredItems.length === 0 && (
              <li className="cursor-default select-none relative py-2 pl-3 pr-9 text-gray-500">
                Aucun résultat trouvé
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}

export default DropDownGPT1;
